// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyBJI7X36JrZvKNaNJyzuwz_IHd4jKvpI0A",        // <-- check this
//   authDomain: "eccomerce-website-37e07.firebaseapp.com",
//   projectId: "eccomerce-website-37e07",
//   storageBucket: "eccomerce-website-37e07.firebasestorage.app",
//   messagingSenderId: "310746686126",
//   appId: "1:310746686126:web:95f883f12622efb2d4833f",
// };

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// const firebaseConfig = {
//   apiKey: "AIzaSyAjgVrgg0XykpS5WZvcJohCWBogoRVABAQ",
//   authDomain: "vallalarnaturalsecommerce.firebaseapp.com",
//   projectId: "vallalarnaturalsecommerce",
//   storageBucket: "vallalarnaturalsecommerce.firebasestorage.app",
//   messagingSenderId: "309723546600",
//   appId: "1:309723546600:web:93cc666b2415eef3c8da5d",
//   measurementId: "G-7F2HNGKBWZ"
// };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
